<template>
    <div class="container">
        <div>
            <CommonBreadcrumb class="bread_block" />  
        </div>
        <div class="perfomance_block">
            <div class="banner">
                <picture>
                    <source media="(min-width: 768px)" width="2500" height="700" type="image/webp" srcset="~/assets/fiery-round/banner.webp">
                    <source media="(min-width: 768px)" width="2500" height="700" type="image/jpeg" srcset="~/assets/fiery-round/banner.jpg">

                    <source media="(max-width: 991x)" width="686" height="452" type="image/webp" srcset="~/assets/fiery-round/banner_mob.webp">
                    <source media="(max-width: 991px)" width="686" height="452" type="image/jpeg" srcset="~/assets/fiery-round/banner_mob.jpg">
                    <img width="2500" height="700" type="image/jpeg" src="~/assets/fiery-round/banner.jpg" class="radious_four" alt="fiery-round">
                </picture>
            </div>
            <div class="title_block">
                <h1 class="title font-active">Light Performance Report</h1>
                <h2 class="sub_title font-active">Fiery Rounds</h2>
                
                <p class="mb-0 text-center">
                    The Light Performance Report by the International Gemological Institute (IGI) is an essential tool when it comes to 
                    <NuxtLink :to="localePath('/loose-diamonds/round-cut-diamond')">round diamonds</NuxtLink>
                    - offering a comprehensive evaluation of how a diamond interacts with light. 
                    While most standard diamond reports focus primarily on the  
                    <NuxtLink :to="localePath('/4-cs-diamond')">4 C’s</NuxtLink>
                    - cut, color, clarity, and carat, 
                    the Light Performance Report focuses on properties such as a diamond’s brilliance, fire, and contrast. 
                    These three characteristics define a diamond’s <b>scintillation</b>, 
                    a quality that many consumers consider to be the most appealing in a diamond.
                </p>
                <p class="mb-0 text-center">
                    Here at Friendly Diamonds, we wanted to go the extra mile for you; 
                    we have curated a line of round diamonds that display top optical performance and have received exceptional grades on IGI’s Light Performance Report.
                </p>
            </div>
        </div>
        <div class="row perfomance_block align-items-center">
            <div class="col-12 col-lg-5 perform_text">
                <h2 class="font-active">What is Light Performance?</h2>
                <p class="mb-2">Light performance in diamonds refers to how the diamond is able to reflect, refract, and disperse light. 
                    A diamond’s interaction with light results in its brilliance, fire, and contrast. The cut of a diamond significantly affects its interaction with light, 
                    making this report a vital part of 
                    <NuxtLink :to="localePath('/blog/what-is-diamond-grading')" v-if="!$country.is_india">diamond grading.</NuxtLink>
                    <span v-else>diamond grading.</span>
                </p>
                <p class="para">This is what a Light Performance Report looks like- it is broken down into 5 grades ranging from ‘Low’ to ‘Exceptional’. 
                    The overall grade is an <b>average of the 3 key aspects.</b>
                </p>
                <NuxtLink :to="localePath({ name:'loose-listing', query: { FieryRound: 'Yes' } })">
                    <div class="button text-center">
                        <span>SHOP FIERY ROUNDS</span>
                    </div>
                </NuxtLink>
            </div>
            
            <div class="col-12 col-lg-7">
                <div class="mb-3 img_box_mod certificate radious_eight">
                    <picture>
                        <source width="1408" height="1060" type="image/webp" srcset="~/assets/fiery-round/certificate.webp">
                        
                        <img width="1408" height="1060" type="image/jpeg" src="~/assets/fiery-round/certificate.jpg" alt="Friendly Community">
                    </picture>
                </div>

                <NuxtLink :to="localePath({ name:'loose-listing', query: { FieryRound: 'Yes' } })">
                    <div class="button1 text-center mx-auto">
                        <span>SHOP FIERY ROUNDS</span>
                    </div>
                </NuxtLink>

            </div>
        </div>
        <div class="row g-1 perfomance_block">
            <div class="col-12 font-active light_bar radious_four">
                <h2 class="mb-0">Key Aspects of Light Performance</h2>
            </div>
            <div class="col-12 col-lg-4 text-center">
                <div class="img_box mb-3 radious_eight">
                    <picture>
                        <source width="260" height="260" type="image/webp" srcset="~/assets/fiery-round/brightness.webp">
                        
                        <img width="260" height="260" type="image/jpeg" src="~/assets/fiery-round/brightness.jpg" alt="Brightness">
                    </picture>
                </div>
                <div class="text_block">
                    <h5 class="font-active">Brightness</h5>
                    <p class="mb-0 mx-md-2">This property is an indication of the amount of white light that is reflected from diamond. 
                        This report evaluates how well a diamond returns light to the observer’s eye.</p>
                </div>
            </div>
            <div class="col-12 col-lg-4 text-center">
                <div class="img_box mb-3 radious_eight">
                        <picture>
                            <source width="260" height="260" type="image/webp" srcset="~/assets/fiery-round/fire.webp">
                           
                            <img width="260" height="260" type="image/jpeg" src="~/assets/fiery-round/fire.jpg" alt="fire">
                        </picture>
            
                </div>
                <div class="text_block">
                    <h5 class="font-active">Fire</h5>
                    <p class="mb-0 mx-md-2">This characteristic focuses on the flashes of color seen by the observer when the diamond is tilted. 
                        A diamond with more flashes of color is considered more appealing to a consumer.
                    </p>
                </div>
            </div>
            <div class="col-12 col-lg-4 text-center">
                    <div class="img_box mb-3 img_box_mod radious_eight">
                        <picture>
                            <source width="260" height="260" type="image/webp" srcset="~/assets/fiery-round/contrast.webp">
                            <img width="260" height="260" type="image/jpeg" src="~/assets/fiery-round/contrast.jpg" alt="Contrast">
                        </picture>
                	</div>
                <div class="text_block">
                    <h5 class="font-active">Contrast</h5>
                    <p class="mb-0 mx-md-2">Contrast refers to the variation between light and dark areas in a diamond, which contributes towards a diamond’s overall visual appeal and sparkle when the diamond is moved.</p>
                </div>
            </div>
        </div>
		<div class="row g-0">
			<div class="col-12">
				<div class="font-active light_bar radious_four">
					<h2 class="mb-0">Benefits of Light Performance</h2>
				</div>
			</div>
		</div>
		<div class="light_perform">
            <div class="four_box_text last_light">
                <div class="last_text">
                    <h3 class="mb-0 number font-active">1</h3>
                    <h3 class="sub_heading">Confidence</h3>
                    <p class="mb-0 desc">An analysis of a diamond’s interaction with light gives you confidence in your purchase. 
                        This is why we decided to introduce the ‘Fiery Rounds’ collection.
                    </p>
                </div>
            </div>
            <div class="four_box_text last_light">
                <div class="last_text">
                    <h3 class="mb-0 number font-active">2</h3>
                    <h3 class="sub_heading">Value Awareness</h3>
                    <p class="mb-0 desc">Purchasing diamonds is a big decision and understanding how the value of your diamond is determined can help you make a more informed decision.</p>
                </div>
            </div>
            <div class="four_box_text last_light">
                <div class="last_text">
                    <h3 class="mb-0 number font-active">3</h3>
                    <h3 class="sub_heading ">Trust</h3>
                    <p class="mb-0 desc">This report offers an objective assessment of a diamond’s optical properties. This transparency helps build trust with consumers.</p>
                </div>
            </div>
            <div class="four_box_text last_light">
                <div class="last_text">
                    <h3 class="mb-0 number font-active">4</h3>
                    <h3 class="sub_heading ">Education</h3>
                    <p class="mb-0 desc">At Friendly Diamonds, we truly believe in educating our consumers and ensuring that they are happy with their decisions.</p>
                </div>
            </div>
        </div>

        <NuxtLink :to="localePath({ name:'loose-listing', query: { FieryRound: 'Yes' } })">
            <div class="button2 text-center mx-auto">
                <span>SHOP NOW</span>
            </div>
        </NuxtLink>

        <div class="row perfomance_block">
            <div class="col-12 click_bar text-center">
                <p class="mb-0">To learn more about IGI Light Performance Report, please visit </p>
                <a rel="nofollow noopener" target="_blank" href="https://www.igi.org/grading-process/cut-grading/">https://www.igi.org/grading-process/cut-grading/</a>
            </div>
        </div>
    </div>
</template>

<script setup>
    useFetchMeta( useNuxtApp(), useRuntimeConfig());
    const { $country } = useNuxtApp();
    const localePath = useLocalePath();
    
</script>

<style scoped>
.para {
   margin-bottom: 32px;
}

.button {
    background: var(--green);
    padding: 3% 5%;
    border-radius: 4px;
    /* width: 60%; */
    min-width: 240px;
    max-width: 240px;
    cursor: pointer;
    
}

.button span {
    font-size: 14px;
    letter-spacing: 1.5px;
    color: #ffffff;
}

.button1 {
    background: var(--green);
    padding: 14px 30px;
    border-radius: 4px;
    /* width: 60%; */
    min-width: 240px;
    max-width: 240px;
    cursor: pointer;
    display: none;
    margin: 20px 0;
}

.button1 span {
    font-size: 14px;
    letter-spacing: 1.12px;
    color: #ffffff;
}

.button2 {
    background: var(--green);
    padding: 14px 30px;
    margin: 3% 3%;
    border-radius: 4px;
    min-width: 240px;
    max-width: 240px;
    margin-top: 40px;
    margin-bottom: 40px;
}

.button2 span {
    font-size: 14px;
    letter-spacing: 1.5px;
    color: #ffffff;
}

.certificate {
    width: 100%; 
    overflow: hidden; 
}

.title{
    margin: 16px 0;
    text-align: center;
    color: #212529;
}
h1 {
    font-size: 32px;
}
.sub_title{
    color: #668b84;
    font-size: 26px;
    text-align: center;
    margin-bottom: 12px;
}

.title_block p{
	margin: 12px 0;
}
p{
    color: #606060;
    font-size: 16px;
}
.perfomance_block{
    margin: 4% 0;
}
.perform_text h2{
    font-size: 24px;
}
.perform_text{
    text-align: left;
}
.light_perform {
    display: flex;
    justify-content: space-between; 
	flex-wrap: wrap;
}

.four_box_text {
    flex: 1; 
    margin-right: 24px; 
}

.four_box_text:last-child {
    margin-right: 0;
}

.light_bar{
    text-align: center;
    background: #668b844c 30%;
    padding: 12px 18px;
    margin-bottom: 24px;
}
.click_bar a{
    text-decoration: underline;
    font-style: italic;
}
.light_bar h2{
    font-size: 24px;
    color: #353535;
}
.text_block{
    margin: 12px 0;
    text-align: center;
}
.last_text{
    padding: 20px;
    border: 1px dashed #668b844c;
    border-radius: 4px;
    height: 100%;
}
.last_text .number{
    font-style: italic;
    font-size: 48px;
    color: #668b84;
}
.last_text .sub_heading{
    font-size: 16px;
    margin: 12px 0;
    text-transform: uppercase;
    color: #212529;
    letter-spacing: 2px;
    font-weight: 600;
}
.certificate img{
    border: 2px solid #eaeaea;
    border-radius: 8px;
}
.last_text .desc{
    color: #606060;
}
.last_light{
   text-align: center;
}
.click_bar p{
    font-size: 16px;
    text-align: center;
    font-style: italic;
}

.img_box{
    max-width: 100%;
    max-height: 100%;
}
.img_box img{
    transition: 0.8s; 
    /* image-rendering: pixelated; */
}
.img_box img:hover{
    transform: scale(1.1);
    transition: 0.8s;
}

@media(max-width:991px) {

    .button{
        display: none;
    }

    .button1 {
        display: block;
    }
}


@media (max-width : 992px){
    
    .four_box_text {
        flex: 0 0 48%; 
        margin-bottom: 24px;
    }
    .perform_text{
        margin-bottom: 15px;
        text-align: center;
    }
    .light_bar{
        margin-bottom: 16px;
    }
    .light_bar{
        padding: 8px 12px;
    }
    .last_light{
        margin: 16px 0;
    }
    .text_block{
        margin: 12px 0;
    }
}
@media (max-width : 767px){
    .title {
        margin: 12px 0;
    }
    .title_block p{
        margin: 8px 0;
    }
    .certificate {
        overflow-x: auto; 
    }
    .certificate img {
        min-width: 550px; 
        height: auto; 
    }
    .sub_title{
        font-size: 20px;
        margin-bottom: 12px;
    }
    .four_box_text {
        flex: 0 0 100%; 
        margin-bottom: 24px;
    }
        
    h1{
        font-size: 24px;
    }
    p{
        font-size: 14px;
    }
    .perform_text h2{
        font-size: 20px;
    }
    .perform_text{
        text-align: center;
    }
    .img_box{
        margin: 20px 0;
    }
    .light_bar{
        padding: 12px 8px;
        margin-bottom: 16px;
    }
    .light_bar h2{
        font-size: 20px;
    }
    .last_light{
        margin: 8px 0;
    }
    .last_text {
        min-height: auto;
    }
    .last_text .number{
        font-size: 32px;
    }
    .last_text .sub_heading{
        font-size: 16px;
        margin: 8px 0;
        letter-spacing: 2px;
    }
    .click_bar p, a{
        font-size: 14px;
    }
}
</style>